import React, { ElementType, useEffect, useState } from 'react';
import { usePosting } from '../Hooks';
import { Icon, IconName, Header } from 'react-frontier';

type SidebarBadgeItemProps<E extends ElementType> = {
	postingId: number,
	text: string,
	iconName: IconName,
	as?: E
} & React.ComponentPropsWithoutRef<E>

var SidebarBadgeItem = <E extends ElementType>(props: SidebarBadgeItemProps<E>)=>{
	var { posting_name, pending_users, loading } = usePosting(props.postingId);
	var {
		postingId,
		text,
		iconName,
		as,
		...restProps
	} = props;

	const ComponentType = props.as ?? 'div';

	if(loading) return <Header loading size='mini'/>

	return <ComponentType className="item badge" {...restProps}>
		<Icon name={props.iconName} />
		<div className="text">{props.text}</div>
		{(!!posting_name && pending_users>0) && (
			<div className="badge">{pending_users}</div>
		)}
	</ComponentType>
}

export default SidebarBadgeItem;